import "/polyfills/closest";
import "/modules/modals";
import events from "/events";
import user from "/utils/user";
import globals from "/utils/globals";

// As Vue destroy the modals on close,
// we need to execute replace logic on modal open
// That's why we save them on trigger click,
// replace on modal open, delete saved values on modal close

let signupPath;
let loginPath;
let baseSignupHeadlineCopy;
let baseSignupSubheadlineCopy;
let signupHeadlineCopy;
let signupSubheadlineCopy;

events.on("modal:auth-popup:step:signup:opened", () => {
  /* Replace headline and subheadline if needed */
  const signupHeadline = document.querySelector(".auth-popup-form__headline");
  const signupSubheadline = document.querySelector(".auth-popup-form__subheadline");
  // Save default copies
  if (!baseSignupHeadlineCopy) {
    baseSignupHeadlineCopy = signupHeadline.innerHTML;
  }
  if (!baseSignupSubheadlineCopy) {
    baseSignupSubheadlineCopy = signupSubheadline.innerHTML;
  }
  // Replace if different
  signupHeadline.innerHTML = signupHeadlineCopy || baseSignupHeadlineCopy;
  signupSubheadline.innerHTML = signupSubheadlineCopy || baseSignupSubheadlineCopy;

  // Replace signup action if needed
  const signupForm = document.querySelector(".js-popup-signup-form");
  if (signupForm && signupPath) {
    signupForm.setAttribute("action", signupPath);
  }

  events.emit("facebook.init");
});

events.on("modal:auth-popup:step:login:opened", () => {
  // Replace login action if needed
  const loginForm = document.querySelector(".js-popup-login-form");
  if (loginForm && loginPath) {
    loginForm.setAttribute("action", loginPath);
  }

  events.emit("facebook.init");
  events.emit("google:login");
});

events.on("modal:auth-popup:closed", () => {
  // Delete saved values on popup closed
  signupHeadlineCopy = null;
  signupSubheadlineCopy = null;
  signupPath = null;
  loginPath = null;
});

document.addEventListener("click", e => {
  // Global class to open signup on click
  const openSignupTarget = e.target.closest(".js-open-signup-popup");
  if (openSignupTarget  && !user.isLoggedIn()) {
    e.preventDefault();
    setSignupCopies(openSignupTarget);

    onAuthTriggerAction("signup", openSignupTarget);
  }

  // Global class to open login on click
  const openLoginTarget = e.target.closest(".js-open-login-popup");
  if (openLoginTarget && !user.isLoggedIn()) {
    e.preventDefault();

    onAuthTriggerAction("login", openLoginTarget);
  }

  // Save signup action if needed
  const signupTarget = e.target.closest("[data-signup-path]");
  if (signupTarget) {
    signupPath = signupTarget.dataset.signupPath;
  }

  // Save login action if needed
  const loginTarget = e.target.closest("[data-login-path]");
  if (loginTarget) {
    loginPath = loginTarget.dataset.loginPath;
  }

  // Show / hide password
  const passwordTarget = e.target.closest(".js-password-toggle");
  if (passwordTarget) {
    const field = passwordTarget.closest(".form__field");
    if (field) {
      const input = field.querySelector("input[name='signup[password]']");
      if (input.getAttribute("type") === "password") {
        input.setAttribute("type", "text");
        passwordTarget.classList.add("password-toggle--shown");
      } else {
        input.setAttribute("type", "password");
        passwordTarget.classList.remove("password-toggle--shown");
      }
      input.focus();
    }
  }
});

// Save auth copy if data attributes are set
// data-signup-headline / data-signup-subheadline
const setSignupCopies = (trigger) => {
  signupHeadlineCopy = trigger.dataset.signupHeadline;
  signupSubheadlineCopy = trigger.dataset.signupSubheadline;
};

function onAuthTriggerAction(type, target) {
  if (user.isLoggedIn() && target.classList.contains("js-redirect-on-auth-trigger")) {
    if (!target.href) {
      return;
    }
    window.location.href = globals.routes.library;
  } else {
    if (globals.seeSignupDiscount) {
      events.emit(`abtest:modal:auth-popup:step:${type}:show`);
    } else {
      events.emit(`modal:auth-popup:step:${type}:show`);
    }
  }
}
